import config from "../config/config";

export const I18N_LABELS = {
    SIDEBAR_DRIVERS_STATUS_FREE: 'sidebar_drivers_status_free',
    SIDEBAR_DRIVERS_STATUS_RETURNING: 'sidebar_drivers_status_returning',
    SIDEBAR_DRIVERS_STATUS_BUSY: 'sidebar_drivers_status_busy',
    SIDEBAR_ORDERS_DELIVERY_LABEL: 'sidebar_orders_delivery_label',
    SIDEBAR_ORDERS_SCHEDULED_LABEL: 'sidebar_orders_scheduled_label',
    NO_SIDEBAR_DELIVERY_DRIVER: 'no_sidebar_delivery_driver',
    SIDEBAR_DELIVERY_DRIVER: 'sidebar_delivery_driver',
    SIDEBAR_DELIVERY_PROCESS: 'sidebar_delivery_process',
    SIDEBAR_DELIVERY_NAME: 'sidebar_delivery_name',
    SIDEBAR_DELIVERY_STATE: 'sidebar_delivery_state',

    STATS_DELIVERY_TIME_LABEL: 'stats_delivery_time_label',
    STATS_GAUGE_KITCHEN_LABEL: 'stats_gauge_kitchen_label',
    STATS_GAUGE_DISPATCH_LABEL: 'stats_gauge_dispatch_label',
    STATS_GAUGE_DRIVING_LABEL: 'stats_gauge_driving_label',
    STATS_GAUGE_DELIVERY_LABEL: 'stats_gauge_delivery_label',

    // Mock Data
    MOCK_STORE_NAME: 'mock_store_name',
    MOCK_DRIVER_01_NAME: 'mock_driver_01_name',
    MOCK_DRIVER_02_NAME: 'mock_driver_02_name',
    MOCK_DRIVER_03_NAME: 'mock_driver_03_name',
    MOCK_DRIVER_04_NAME: 'mock_driver_04_name',
    MOCK_DRIVER_05_NAME: 'mock_driver_05_name',
    MOCK_DRIVER_06_NAME: 'mock_driver_06_name',
    MOCK_DRIVER_07_NAME: 'mock_driver_07_name',
    MOCK_DRIVER_08_NAME: 'mock_driver_08_name',
    MOCK_DRIVER_09_NAME: 'mock_driver_09_name',
    MOCK_DRIVER_10_NAME: 'mock_driver_10_name',
    MOCK_ORDER_ONE_ADDRESS: 'mock_order_one_address',

    AUTH_VIEW_LOADING_MESSAGE: 'auth_view_loading_message',

    LOADING_MESSAGE: 'loading_message',

    DRIVER_IN_DANGER_NAME: 'driver_in_danger_name',
    DRIVER_IN_DANGER_DRIVER_NAME_LABEL: 'driver_in_danger_driver_name_label',
    DRIVER_IN_DANGER_ALARM_ID_LABEL : 'driver_in_danger_alarm_id_label',
    DRIVER_IN_DANGER_DRIVER_LOCATION: 'driver_in_danger_driver_location',
    DRIVER_IN_DANGER_CLOSE_BUTTON : 'driver_in_danger_close_button',

    UNAUTHORISED_TITLE: 'unauthorised_title',
    UNAUTHORISED_GO_BACK: 'unauthorised_go_back',
    UNAUTHORISED_PAGE_NAME_LINK: 'unauthorised_page_name_link',

    PAGE_NOT_FOUND_ERROR_TITLE: 'page_not_found_error_title',
    PAGE_NOT_FOUND_ERROR_SUB_TITLE: 'page_not_found_error_sub_title',
    PAGE_NOT_FOUND_ERROR_GO_BACK: 'page_not_found_error_go_back',
    PAGE_NOT_FOUND_ERROR_PAGE_NAME_LINK: 'page_not_found_error_page_name_link',
}


const i18n_messages = {
    en: {
        sidebar_drivers_status_free: 'AVAILABLE',
        sidebar_drivers_status_returning: 'RETURNING',
        sidebar_drivers_status_busy: 'OCCUPIED',
        sidebar_orders_delivery_label: 'Deliveries',
        sidebar_orders_scheduled_label: 'Scheduled',
        no_sidebar_delivery_driver: 'Unassigned',
        sidebar_delivery_driver: 'Delivery Driver',
        sidebar_delivery_process: 'Delivery Process',
        sidebar_delivery_name: 'Delivery Name',
        sidebar_delivery_state: 'Delivery State',

        stats_delivery_time_label: 'Delivery Time',
        stats_gauge_kitchen_label: 'Kitchen',
        stats_gauge_dispatch_label: 'Dispatch',
        stats_gauge_driving_label: 'Driving',
        stats_gauge_delivery_label: 'Delivery',


        mock_store_name: 'DeliveryTracker',
        mock_driver_01_name: 'John Silver',
        mock_driver_02_name: 'Oliver Stone',
        mock_driver_03_name: 'Luis Henrique',
        mock_driver_04_name: 'Rose Blouberg',
        mock_driver_05_name: 'Jenifer Alba',
        mock_driver_06_name: 'Michael Knight',
        mock_driver_07_name: 'Cristian Robert',
        mock_driver_08_name: 'John Bush',
        mock_driver_09_name: 'Carlos Santana',
        mock_order_one_address: '',

        auth_view_loading_message: 'logging in...',

        loading_message: 'Loading...',

        driver_in_danger_name: 'Driver In Danger',
        driver_in_danger_driver_name_label: 'Name',
        driver_in_danger_alarm_id_label: 'Alarm',
        driver_in_danger_driver_location: 'Location',
        driver_in_danger_close_button: 'Close',

        unauthorised_title: 'Unauthorised',
        unauthorised_go_back: 'Go Back To',
        unauthorised_page_name_link: 'HOME PAGE',

        page_not_found_error_title: 'Error 404',
        page_not_found_error_sub_title: 'PAGE NOT FOUND!',
        page_not_found_error_go_back: 'Go Back To',
        page_not_found_error_page_name_link: 'Home Page',
    },
    pt: {
        sidebar_drivers_status_free: 'LIVRES',
        sidebar_drivers_status_returning: 'DE REGRESSO',
        sidebar_drivers_status_busy: 'OCUPADOS',

        stats_delivery_time_label: 'Tempo Público',
        stats_gauge_kitchen_label: 'Cozinha',
        stats_gauge_dispatch_label: 'Preparação',
        stats_gauge_delivering_label: 'Na Rua',
        stats_gauge_delivery_label: 'Entrega',
        no_sidebar_delivery_driver: 'Não Atribuido',
        sidebar_delivery_driver: 'Nome do Entregador',
        sidebar_delivery_process: 'Processo da Encomenda',
        sidebar_delivery_name: 'Nome da Encomenda',
        sidebar_delivery_state: 'Estado da Encomenda',

        sidebar_orders_delivery_label: 'Entregas',
        sidebar_orders_scheduled_label: 'Agendamentos',

        // Mock data
        mock_store_name: 'DeliveryTracker',
        mock_driver_01_name: 'André Silva',
        mock_driver_02_name: 'Tiago Rodrigues',
        mock_driver_03_name: 'Rui Andorinha',
        mock_driver_04_name: 'Guilherme Santos',
        mock_driver_05_name: 'João Barrigas',
        mock_driver_07_name: 'Bruno Azevedo',
        mock_driver_08_name: 'Vasco Pinto',
        mock_driver_09_name: 'Luis Abril',
        mock_driver_10_name: 'Carlos Santana',
        mock_order_01_address: '',

        auth_view_loading_message: 'A Iniciar Sessão...',

        loading_message: 'A carregar...',

        driver_in_danger_name: 'Entregador Em Perigo',
        driver_in_danger_driver_name_label: 'Nome',
        driver_in_danger_alarm_id_label: 'Alarme',
        driver_in_danger_driver_location: 'Localização',
        driver_in_danger_close_button: 'Fechar',

        unauthorised_title: 'Não Autorizado',
        unauthorised_go_back: 'Regressar para a',
        unauthorised_page_name_link: 'Página Inicial',

        page_not_found_error_title: 'Erro 404',
        page_not_found_error_sub_title: 'Página Não Encontrada!',
        page_not_found_error_go_back: 'Regressar para a',
        page_not_found_error_page_name_link: 'Página Inicial',
    }
};

export function i18n_get_value(label_id) {
    let userLang = navigator.language || navigator.userLanguage;

    // using only the language, discarding the country is available
    userLang =
        userLang !== undefined ? userLang.split("-")[0].trim() : config.locale;

    const locale = userLang in i18n_messages ? userLang : "pt";

    let label_value = i18n_messages[locale][label_id];

    if (label_value === undefined) {
        label_value = i18n_messages['pt'][label_id];
        console.debug("No message defined for label[" + label_id + "], using PT(" + label_value + ")");
    }

    if (label_value === undefined) {
        label_value = 'no-value';
        console.error("No message defined for label[" + label_id + "]");
    }

    return label_value;
}

export default {
    i18n_get_value,
    I18N_LABELS
};
